import React, { useEffect, useState } from "react";
import CachedIcon from '@mui/icons-material/Cached';

interface CaptchaProps {
  image: string|undefined;
  refetch: any
}

const Captcha: React.FC<CaptchaProps> = ({image,refetch}) => {

  return (
    <>
      <div style={{display: "flex"}}>
        <img src={`data:image/png;base64,${image}`} alt="Captcha" />
      <button type="button" onClick={() => refetch()} style={{border:"1px solid lightGrey", borderRadius:"4px"}}>
      <CachedIcon fontSize="large"/>
      </button>
      </div>

    </>
  );
};

export default Captcha;
